import type { ImageProps } from 'next/image'

interface ImageData extends Pick<ImageProps, 'src' | 'width' | 'height'> {}

const MOBILE_HEIGHT = 40
const DESKTOP_HEIGHT = 59

const hearmeMobile: ImageData = { src: '/images/svg/logos/logo-business-hearme.svg', width: 192, height: MOBILE_HEIGHT }
const hearmeDesktop: ImageData = {
  src: '/images/svg/logos/logo-business-hearme.svg',
  width: 283,
  height: DESKTOP_HEIGHT,
}
const hedepyMobile: ImageData = {
  src: '/images/svg/logos/logo-business-vertical.svg',
  width: 89,
  height: MOBILE_HEIGHT,
}
const hedepyDesktop: ImageData = {
  src: '/images/svg/logos/logo-business-horizontal.svg',
  width: 249,
  height: DESKTOP_HEIGHT,
}

export const getBusinessLogoProps = (displayHearme: boolean) => {
  const imageDataDesktop = displayHearme ? hearmeDesktop : hedepyDesktop
  const imageDataMobile = displayHearme ? hearmeMobile : hedepyMobile

  const alt = displayHearme ? 'Hedepy Business, former HearMe' : 'Hedepy Business'

  return { desktopProps: { ...imageDataDesktop, alt }, mobileProps: { ...imageDataMobile, alt } }
}
